// client/src/utils/logger.js

/**
 * Simple logging utility to replace console methods in production
 * Can be extended to send logs to external services
 */
class Logger {
  constructor() {
    this.isDevelopment = process.env.NODE_ENV === 'development'
  }

  error(message, error = null, context = {}) {
    if (this.isDevelopment) {
      console.error(message, error, context)
    }
    // TODO: In production, send to error tracking service (e.g., Sentry)
    // this.sendToErrorService('error', message, error, context)
  }

  warn(message, context = {}) {
    if (this.isDevelopment) {
      console.warn(message, context)
    }
    // TODO: In production, send to logging service
  }

  info(message, context = {}) {
    if (this.isDevelopment) {
      console.info(message, context)
    }
  }

  debug(message, context = {}) {
    if (this.isDevelopment) {
      console.debug(message, context)
    }
  }

  // TODO: Implement external service integration
  // sendToErrorService(level, message, error, context) {
  //   // Send to Sentry, LogRocket, or other service
  // }
}

const logger = new Logger()
export default logger
